/**
 * @file paddle model center
 * @author wanzhongyun
 */

import React from 'react';

// import Header from '../../components/header/HeaderWithStore';
// import Footer from '../../components/footer/footer';
// import { IndexContainer } from '@baidu/ai-studio-component-modelcenter';
// import RightNavigation from '../../components/right-navigation/RightNavigation';
// import { ENV } from '@baidu/ai-studio-store-modelcenter';
const ModelCenter: React.FC = () => {
    return (
        <div>
            {/* <Header />
            <div className="paddle-model-center">
                <IndexContainer prefixApi="modelcenter" env={ENV.paddle} />
            </div>
            <RightNavigation />
            <Footer /> */}
        </div>
    );
};

export default React.memo(ModelCenter);
